import { defineComponent as _defineComponent } from 'vue'
import BRadioCard from 'JS/components/blain-form/BRadioCard.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentStepOption',
  props: {
    title: null
  },
  setup(__props: any) {



return { __sfc: true,BRadioCard }
}

})